// src/config/featureFlags.js
/**
 * Feature Flags Configuration
 * Control which features are enabled/disabled across the application
 */

export const FEATURE_FLAGS = {
  // Practice Mode Features
  VOCABULARY: true,
  GRAMMAR: true,
  REDEMITTEL: true, // Coming Soon

  // Exam-based Practice
  READING_PRACTICE: true, // Coming Soon
  LISTENING_PRACTICE: true, // Coming Soon
  WRITING_PRACTICE: true, // Coming Soon
  SPEAKING_PRACTICE: true, // Coming Soon

  // Main Features
  LEARNING_PATH: true, // Coming Soon (Study Plan/Lessons)
  EXAM_SIMULATOR: true, // Coming Soon
  WRITING_LAB: false, // Coming Soon - Disabled

  // Additional Features
  STUDY_PLAN: true // Coming Soon
};

/**
 * Party games (Articulate, Top 10, Fishbowl, Psych!, Dixit) are dev-only:
 * hidden from the live site and left out of the production bundle.
 */
export const GAMES_ENABLED = import.meta.env.DEV;

/**
 * Check if a feature is enabled
 * @param {string} featureName - Name of the feature from FEATURE_FLAGS
 * @returns {boolean}
 */
export const isFeatureEnabled = (featureName) => {
  return FEATURE_FLAGS[featureName] === true;
};

/**
 * Get all coming soon features
 * @returns {Array} Array of feature names that are coming soon
 */
export const getComingSoonFeatures = () => {
  return Object.keys(FEATURE_FLAGS).filter(key => !FEATURE_FLAGS[key]);
};

/**
 * Feature metadata for Coming Soon page
 */
export const FEATURE_METADATA = {
  LEARNING_PATH: {
    icon: '🎓',
    titleKey: 'comingSoon.features.learningPath.title',
    descriptionKey: 'comingSoon.features.learningPath.description',
    benefits: [
      'comingSoon.features.learningPath.benefit1',
      'comingSoon.features.learningPath.benefit2',
      'comingSoon.features.learningPath.benefit3'
    ]
  },
  EXAM_SIMULATOR: {
    icon: '📝',
    titleKey: 'comingSoon.features.examSimulator.title',
    descriptionKey: 'comingSoon.features.examSimulator.description',
    benefits: [
      'comingSoon.features.examSimulator.benefit1',
      'comingSoon.features.examSimulator.benefit2',
      'comingSoon.features.examSimulator.benefit3'
    ]
  },
  WRITING_LAB: {
    icon: '✍️',
    titleKey: 'comingSoon.features.writingLab.title',
    descriptionKey: 'comingSoon.features.writingLab.description',
    benefits: [
      'comingSoon.features.writingLab.benefit1',
      'comingSoon.features.writingLab.benefit2',
      'comingSoon.features.writingLab.benefit3'
    ]
  },
  STUDY_PLAN: {
    icon: '📅',
    titleKey: 'comingSoon.features.studyPlan.title',
    descriptionKey: 'comingSoon.features.studyPlan.description',
    benefits: [
      'comingSoon.features.studyPlan.benefit1',
      'comingSoon.features.studyPlan.benefit2',
      'comingSoon.features.studyPlan.benefit3'
    ]
  }
};

export default FEATURE_FLAGS;